import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { IAutochargeConfigResponseDTO, IRiderObject, IStoreState } from '../../../types/index'
import AutochargeModal from '.././../../components/riders/riderdetails/wallet/AutochargeModal'
import { updateRiderAutochargeConfig } from '../../../state/actions/riders'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    onClose: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    updateAutochargeWallet: (rider: IRiderObject, autocharge: IAutochargeConfigResponseDTO) => {
      return dispatch(updateRiderAutochargeConfig(rider.id, autocharge))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutochargeModal)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/AutochargeModal.tsx